import {
    get,
    post
} from './http-calls';

export const saveDocumentStamps = async (jobId, docId, docName, stamps) => {
    let res = await post(`Jobdocuments/SetDocumentStampsJSON`, {
        headerRecordId: jobId,
        ocrDocumentId: docId,
        documentName: docName,
        documentStampsJSON: stamps
    }, {
        useAuthToken: true
    });
    return res;
}

export const getDocumentStamps = async (jobId, docId, docName) => {
    let res = await get(`Jobdocuments/GetDocumentStampsJSON/${jobId}?ocrDocumentId=${docId}&documentName=${docName}`, {
        useAuthToken: true
    });
    return res;
}
